export default {
    name: 'niveau-priorite',
    components: {},
    props: [],
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        updateTitle() {
            this.$refs.niveau.readOnly = false;
            this.$refs.niveau.focus();
        }
    }
}